export const peopleDefaultExpandedViewSection = 'ExpandedViewContactSection';
export const groupDefaultExpandedViewSection = 'ExpandedView';
export const groupMemberExpandedViewSection = 'ExpandedViewGroupMembersSection';
export const groupTransferOwnershipDialog = 'ExpandedViewTransferOwnershipDialog';
export const distributionListExpandedViewSection = 'ExpandedViewDistributionListMembersSection';
